import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import UserTab from "./UserTab";
import Modal from 'react-bootstrap/Modal';
const initialFieldValues = {
    applicationLenderId: "00000000-0000-0000-0000-000000000000",
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    lenderId: "00000000-0000-0000-0000-000000000000",
    status: "PENDING",
    amount: 0,
    loanAmount: 0,
    rate: 0,
    paybackAmount: 0,
    paymentFrequency: "",
    numberOfPayments: 0,
    commissionPoints: 0,
    commission: 0,
    reason: "",
    description: "",
    conditions: ""
};
export default function LenderOffers() {
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [clientData, setClientData] = useState('');// client number
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [offers, setOffers] = useState([]);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [subject, setSubject] = useState('');
    const [emailContent, setEmailContent] = useState('');
    const [status, setStatus] = useState('PENDING');
    const [files, setFiles] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [templateSubject, setTemplateSubject] = useState("");
    const handleEmailTemplate = (e) => {
        e.preventDefault();
        if (e.target.value !== "custom") {
            const selectedRecord = templates.find(record => record.userTemplateId === e.target.value);
            setSubject(selectedRecord.subject);
            setEmailContent(selectedRecord.content);
        }
        else {
            setSubject("");
            setEmailContent("");
        }
        setTemplateSubject(e.target.value);
    }
    const GetTemplates = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSERTEMPLATES + "?UserId=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setTemplates(response.data.data?.data);
                }
            });
    };
    const handleOpenEmailModal = () => {
        if (clientData.emailAvailable > 0) {
            setShowEmailModal(true)
        }
        else {
            handleError("InSufficient email quota.Please recharge");
        }
    };
    const handleCloseEmailModal = () => {
        setShowEmailModal(false);
        resetForm();
    };
    const GetClientData = () => {
        axios.get(config.APIACTIVATEURL + config.GETUSER + "?Id=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    if (response.data.data !== null) {
                        setClientData(response.data.data);
                    }
                }
            });
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const validate = () => {
        let temp = {};
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e, data) => {
        e.preventDefault();
        setValues(data);
        setStatus("ACCEPTED");
        handleOpenEmailModal();
        /* if (validate()) {
            setLoading(true);
            handleUpdate(data, "ACCEPTED");
        } */
    }
    const handleRevise = (e, data) => {
        e.preventDefault();
        setValues(data);
        setStatus("REQUESTFORREVISE");
        handleOpenEmailModal();
    }
    const handleDecline = (e, data) => {
        e.preventDefault();
        setValues(data);
        setStatus("DECLINED");
        handleOpenEmailModal();
    }
    const handleSendEmail = () => {
        if (validate()) {
            setLoading(true);
            handleUpdate(values, status);
        }
    }
    const handleUpdate = (values, status) => {
        if (validate()) {
            setLoading(true);
            const formData = new FormData();
            formData.append('applicationLenderId', "00000000-0000-0000-0000-000000000000");
            formData.append('lendingApplicationId', values.lendingApplicationId);
            formData.append('lenderId', values.lenderId);
            formData.append('userId', localStorage.getItem('userId'));
            formData.append('clientId', localStorage.getItem('clientId'));
            formData.append('status', status);
            formData.append('domainurl', window.location.origin);
            formData.append('amount', values.amount);
            formData.append('loanAmount', values.loanAmount);
            formData.append('rate', values.rate);
            formData.append('paybackAmount', values.paybackAmount);
            formData.append('paymentFrequency', values.paymentFrequency);
            formData.append('numberOfPayments', values.numberOfPayments);
            formData.append('commissionPoints', values.commissionPoints);
            formData.append('commission', values.commission);
            formData.append('reason', values.reason);
            formData.append('description', values.description);
            formData.append('conditions', values.conditions);
            formData.append('emailSubject', subject);
            formData.append('emailBody', emailContent);
            files.forEach((file, index) => {
                formData.append('pdfFiles', file);
            });
            addOrEdit(formData);
        }
    }
    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
    };
    const applicationAPI = () => {
        return {
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATEAPPLICATIONLENDER, updateRecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        applicationAPI()
            .update(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Application successfully updated");
                    GetLenders();
                    setLoading(false);
                    handleCloseEmailModal();
                }
                else {
                    handleError(res.data.message);
                }
            })
            .catch(function (error) {
                handleError("Error in updating data");
            });

    };
    const resetForm = () => {
        setErrors({});
    };
    const GetLenders = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLOANBYAPPLICATION + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setOffers(response.data.data.data);
                }
            });
    };
    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetLenders();
        GetClientData();
        GetTemplates();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                        <UserTab pagename="offers"></UserTab>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-4">
                                <h5 className="card-title flex-grow-1 mb-0">Lender Offers</h5>
                            </div>
                            {offers.length > 0 ?
                                <div className="row">
                                    {offers.map(offer =>
                                        <div className="col-6">
                                            <div className="card">
                                                <div className="card-header bg-primary text-white d-flex align-items-center">
                                                    <h6 className="text-white mb-0 flex-grow-1">{offer.companyName}</h6>
                                                    {offer.status === "ACCEPTED" ?
                                                        <Link disabled className="fs-2 btn btn-success ms-auto">ACCEPTED</Link>
                                                        :
                                                        <>
                                                            {offer.status === "REQUESTFORREVISE" ?
                                                                <button disabled className="fs-2 btn btn-warning ms-auto me-2 text-black">REQUESTED FOR REVISE</button> :
                                                                <button onClick={(e) => handleRevise(e, offer)} className="fs-2 btn btn-warning ms-auto me-2 text-black">REVISE</button>}
                                                            <button onClick={(e) => handleDecline(e, offer)} className="fs-2 btn ms-auto me-2 text-white" style={{ backgroundColor: "#D60000" }}>{offer.status === "DECLINED" ? "DECLINED" : "DECLINE"}</button>
                                                            <button onClick={(e) => handleSubmit(e, offer)} className="fs-2 btn btn-success ms-auto me-2">ACCEPT</button>
                                                        </>
                                                    }
                                                </div>
                                                <div className="card-body">
                                                    <ul className="list-group px-0">
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Loan Amount :</span>
                                                            <span>USD {offer.loanAmount}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Rate :</span>
                                                            <span>{offer.rate} %</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Payback Amount :</span>
                                                            <span>USD {offer.paybackAmount}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Payment Amount :</span>
                                                            <span>USD {offer.paymentAmount}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Payment Frequency :</span>
                                                            <span>{offer.paymentFrequency}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Number of Payments :</span>
                                                            <span>{offer.numberOfPayments}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Commission Points :</span>
                                                            <span>{offer.commissionPoints}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Commission :</span>
                                                            <span>USD {offer.commission}</span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Conditions :</span>
                                                            <span>{offer.conditions}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                :
                                <h5 className="card-title flex-grow-1 mb-0">
                                    <span className="badge text-bg-success">No Offers Received</span>
                                </h5>}
                        </div>
                        <Modal show={showEmailModal} onHide={handleCloseEmailModal}>
                            <Modal.Header>
                                <Modal.Title>Email</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-lg-12 mb-3">
                                        <label htmlFor="subject" className="form-label">Template</label>
                                        <select className="form-select mb-2" value={templateSubject} onChange={handleEmailTemplate}>
                                            <option value="custom">Add Custom Email</option>
                                            {templates.length > 0 && templates.map(t =>
                                                <option value={t.userTemplateId}>{t.subject}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-lg-12 mb-3">
                                        <label className="form-label">Subject</label>
                                        <input type="text" className="form-control" placeholder="Type your subject here" value={subject} onChange={(e) => setSubject(e.target.value)} required />
                                    </div>
                                    <div className="col-lg-12 mb-3">
                                        <label htmlFor="emailContent" className="form-label">Email Content</label>
                                        <textarea value={emailContent} onChange={(e) => setEmailContent(e.target.value)} className="form-control" rows="5" placeholder="Enter your email content here..." required />
                                    </div>
                                    <div>
                                        <input type="file" multiple onChange={handleFileChange} className="form-control" />
                                    </div>
                                </div>
                                <Modal.Footer>
                                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                        {
                                            loading === false ?
                                                <button
                                                    type="button"
                                                    onClick={handleSendEmail}
                                                    className="btn btn-primary"
                                                    disabled={!subject || !emailContent}
                                                >
                                                    Send Email
                                                </button>
                                                :
                                                <button type="button" className="btn btn-primary" disabled>
                                                    Sending...
                                                </button>
                                        }
                                        <button type="button" className="btn btn-danger" onClick={handleCloseEmailModal}>
                                            Cancel
                                        </button>
                                    </div>
                                </Modal.Footer>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </div >
    );
}